import { useEffect, useState } from 'react'

/**
 * useTimedState
 * @description Custom hook to create a state variable that reverts to the origial value after some time
 * @param {T} `initialValue` this will be the value of the state
 * @param {number} `delay` [`timer`=3000] this is the delay after which the state gets reset
 * @returns ReturnType of useState<T>
 */

const useTimedState = <T,>(initialValue: T, delay: number = 3000) => {
    const [state, setState] = useState<T>(initialValue)

    useEffect(() => {
        const timeout = setTimeout(() => {
            setState(initialValue)
        }, delay)

        return () => {
            timeout && clearTimeout(timeout)
        }
    }, [delay, state, initialValue])

    return [state, setState] as const
}

export default useTimedState
